<template>
    <h2 class="title__section">{{ text }}</h2>
</template>

<script>
export default {
    name: 'Title',
    props:{
        text: String
    }
}
</script>

<style>
    .title__section {
        margin: 15px 0 30px 0;
        position: relative;
        font-size: 20px;
    }

    .title__section::after {
        content: '';
        position: absolute;
        bottom: -9px;
        left: 0;
        width: 100px;
        height: 2px;
        background-color: rgb(91, 182, 91);
    }
</style>